import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { ConfirmDialog } from "primereact/confirmdialog";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'primereact/button';

const EntitlementActivator = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [confirmChangeStatus, setConfirmChangeStatus] = useState(false);

  const acceptLabel = (
    <div style={{ color: 'white' }}>
      <FontAwesomeIcon icon={faCheck} />&nbsp; Yes
    </div>
  );

  const rejectLabel = (
    <div>
      <FontAwesomeIcon icon={faXmark} />&nbsp; No
    </div>
  );

  useEffect(() => {
    if (props.editData) {
      setConfirmChangeStatus(true);
    }
  }, [props.editData]);

  const handleCancel = () => {
    setConfirmChangeStatus(false);
    props.onHide();
  };

  const UpdateEntitlementStatus = (_data) => {
    let functionName = "";
    try {
      functionName = props.page + UpdateEntitlementStatus.name;
      props.onLoading(
        true,
        (_data.STATUS === "Active" ? "Deactivating" : "Activating") +
        " entitlement, please wait..."
      );

      setConfirmChangeStatus(false);

      if (props.type === "RECEIPT") {
        const data = {
          ENTITLEMENT_CLAIM_ID: _data.ENTITLEMENT_CLAIM_ID,
          RECEIPT_FLAG: _data.RECEIPT_FLAG === "Y" ? "N" : "Y",
          UPDATE_ID: userId,
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };

        const action = data.RECEIPT_FLAG === "Y" ? "enabled" : "disabled";

        http
          .post("api/entitlement/UpdateEntitlementClaimReceiptFlag", data, { timeout: 5000 })
          .then(() => {
            toast.success("Receipt requirement successfully " + action + ".");
            props.onReload();
          })
          .catch((err) => {
            toast.error("Failed to update receipt flag. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } else if (props.editData.ENTITLEMENT_LEAVE_ID) {
        const data = {
          ENTITLEMENT_LEAVE_ID: _data.ENTITLEMENT_LEAVE_ID,
          ACTIVE_FLAG: _data.STATUS === "Active" ? "N" : "Y",
          UPDATE_ID: userId,
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };

        const action = data.ACTIVE_FLAG === "Y" ? "Activate" : "Deactivate";

        http
          .post("api/entitlement/UpdateEntitlementStatus", data, { timeout: 5000 })
          .then(() => {
            toast.success("Entitlement is successfully " + action + "d.");
            props.onReload();
          })
          .catch((err) => {
            toast.error("Failed to " + action + " entitlement. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } else {
        const data = {
          ENTITLEMENT_CLAIM_ID: _data.ENTITLEMENT_CLAIM_ID,
          ACTIVE_FLAG: _data.STATUS === "Active" ? "N" : "Y",
          UPDATE_ID: userId,
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };

        const action = data.ACTIVE_FLAG === "Y" ? "Activate" : "Deactivate";

        http
        .post("api/entitlement/UpdateEntitlementClaimStatus", data, { timeout: 5000 })
        .then(() => {
          toast.success("Entitlement is successfully " + action + "d.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to " + action + " entitlement. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
      }
    } catch (err) {
      props.onLoading(false, "Loading...");
      const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
      toast.error("Failed to " + action + " entitlement. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <ConfirmDialog
        visible={confirmChangeStatus}
        onHide={handleCancel}
        content={({ headerRef, contentRef, footerRef, hide }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '2rem',
              backgroundColor: '#fff',
              borderRadius: '12px',
              boxShadow: '0 0 10px rgba(0,0,0,0.15)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: '#0d6efd',
                color: 'white',
                width: '106px',
                height: '106px',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '-78px',
                fontSize: '3rem',
              }}
            >
              <i className="pi pi-question" style={{ fontSize: '2.5rem' }} />
            </div>
        
            <div ref={headerRef} style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>
              Confirmation
            </div>
            <p ref={contentRef} style={{ marginTop: '1rem', fontSize: '1rem' }}>
              {props.type === "RECEIPT"
                ? `Are you sure you want to ${props.editData?.RECEIPT_FLAG === "Y" ? "disable" : "enable"} receipt requirement for this entitlement?`
                : `Are you sure you want to ${props.editData?.STATUS === "Active" ? "deactivate" : "activate"} this entitlement?`
              }
            </p>
            <div ref={footerRef} style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
              <Button
                label={rejectLabel}
                outlined
                style={{ width: '6rem' }}
                onClick={(e) => {
                  hide(e);
                  handleCancel();
                }}
              />
              <Button
                label={acceptLabel}
                style={{ border: 'none', width: '6rem' }}
                onClick={(e) => {
                  hide(e);
                  UpdateEntitlementStatus(props.editData);
                }}
              />
            </div>
          </div>
        )}
        className="custom-confirm-dialog"
      />
    </>
  );
};

export default EntitlementActivator;